<template>
  <div>
  	<el-button type="primary" class="addBtn" @click="addBtnClick">添加标签</el-button>
    <div class="table-wrap">
    	<el-table
		    :data="tableData"
		    border
		    style="width: 100%">
		    <el-table-column
		      prop="sort"
		      label="权重"
		      align="center"
		      width="120"
        >
		    </el-table-column>
		    
        <el-table-column
          prop="tag_name"
          label="标签名称"
          align="center"
        >
        </el-table-column>
		    <el-table-column
		      label="操作"
		      align="center"
		      width="150"
        >
         <template slot-scope="scope">
         	  <div class="operation-wrap">
         	    <span class="opration-item" @click="editLabelClick(scope.row)">编辑</span>
         	    <span class="opration-item" @click="deleteLabelClick(scope.row)">删除</span>
         	  </div>
         </template>
		    </el-table-column>
		  </el-table>
		  <common-pagination
			  :total="total"
        :page_size="page_size"
			  @size-change="handelPagesizeChange"
			  @page-change="handlePageChange"
			></common-pagination>
    </div>
    <common-dialog
    :title="dialogTitle"
    :dialogVisible="dialogVisible"
    @cancel="dialogCancelClick"
    @confirm="dialogConfirmClick"
    @dialog-close="dialogClose"
		>
      <div class="dialog-body-wrap">
  		  <div v-if="dialogType === 'delete'">
          是否删除标签？
        </div>
        <div v-if="dialogType === 'add' || dialogType ==='edit'" class="input-wrap-container">
  		  	<div class="input-wrap">
  		  		<label>标签名称</label>
  		  		<el-input v-model="handle_row.tag_name" placeholder="请输入分类名称"></el-input>
  		  	</div>
  		  	<div class="input-wrap">
  		  		<label>权重</label>
  		  		<el-input v-model="handle_row.sort" type="number" placeholder="请输入权重"></el-input>
  		  	</div>
  		  </div>
      </div>
		</common-dialog>
  </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex';
import { getLabelList, addLabel, editLabel, deleteLabel } from '@/api/label-manage';
import CommonDialog from '@/components/CommonDialog';
import CommonPagination from '@/components/CommonPagination';

export default {
  name: 'casemanage',
  data() {
  	return {
      tableData: [],
      dialogVisible: false,
      dialogTitle: '',
      dialogType: '',
      handle_row: {},
      page_index: '1',  //第几页
  		page_size: '10',
  		total: 0, //总条数
  	}
  },
  computed: {
  	...mapState(['imgDomain'])
  },
  mounted() {
    this._getLabelList();
  },
  components: {
     CommonDialog,
     CommonPagination
  },
  methods: {
    ...mapMutations(['update_article_label']),
    async _getLabelList() {
      const { data, status } = await getLabelList();
      if (status !== 200) return
      this.tableData = data.data;
    },
  	addBtnClick() {
      this.dialogType = 'add';
      this.dialogTitle = '添加标签';
      this.dialogVisible = true;
  	},
  	dialogCancelClick() {
      this.dialogVisible = false;
  	},
  	async dialogConfirmClick() {
      const { sort, tag_name } = this.handle_row;
      if (this.dialogType === 'add' || this.dialogType === 'edit' ) {
          if (!tag_name) {
            this.$message('标签名不能为空')
            return
          }
          if (tag_name.length > 12) {
            this.$message('标签名长度不能超过6')
            return
          }
          if (!sort) {
          this.$message('排序序号不能为空');
          return
          }
          if (+sort < 0 || +sort > 99 || sort%1 !== 0) {
          this.$message('排序序号必须为0～99之间的整数');
          return
          }
          if (this.dialogType === 'add') {
            const { status } = await addLabel(this.handle_row);
            if (status === 200) this.dialogVisible = false;
          } else if (this.dialogType === 'edit') {
            const { status } = await editLabel(this.handle_row)
            if (status === 200) this.dialogVisible = false;
          }
      } else if (this.dialogType === 'delete') {
        const { status } = await deleteLabel(this.handle_row);
        if (status === 200) this.dialogVisible = false;
      }
       console.log(this.handle_row)
  	},
  	dialogClose() {
      this.dialogVisible = false;
      this.handle_row = {};
      this._getLabelList();
  	},
  	handelPagesizeChange() {

  	},
  	handlePageChange() {

  	},
    deleteLabelClick(row) {
      this.handle_row = JSON.parse(JSON.stringify(row));
      this.dialogTitle = '删除公告';
      this.dialogType = 'delete';
      this.dialogVisible = true;
    },
    editLabelClick(row) {
      this.handle_row = JSON.parse(JSON.stringify(row));
      this.dialogType = 'edit';
      this.dialogTitle = '编辑标签';
      this.dialogVisible = true;
    }
  }
}
</script>

<style lang="less" scoped>
@import '~@/assets/styles/variables.less';
.addBtn {
	float: right;
	margin-bottom: 40px;
}
.table-wrap {
	margin-bottom: 40px;
}
.operation-wrap {
	display: flex;
	justify-content: space-around;
	color: @color-text;
	.opration-item{
		cursor: pointer;
	}
}
.dialog-body-wrap {
	text-align: center;
	.input-wrap-container {
		text-align: left;
		.input-wrap {
			margin-bottom: 30px;
		}
	}
}
</style>
